import React from 'react'
import { Link } from 'react-router-dom'
import { Badge } from 'primereact/badge'
import { Conversation } from 'types/messages'
import { blockUser, reportUser } from '_services/actions.services'
import OurImage from './profile/components/OurImage'
import MenuButton from '../../../components/menu-button'
import ReportUser from '../../../components/buttons/ReportUserButton'
import noProfileImage from '../../../assets/images/no_profile_image@2x.png'
import { dislikeUser } from '_services/likes.service'

type ChatItemProps = {
  conversation:Conversation
  unread:number
}

export const ChatItem = (props:ChatItemProps) => {
  const [stateShowBlockReport,setShowBlockReport] = React.useState<boolean>(false)
  const [stateReportReason, setReportReason] = React.useState<string>('')

  const handleReport = async (userId:string) => {
    await reportUser(userId)
    await blockUser(userId)
    setReportReason('')
    setShowBlockReport(false)
  }

  return (
    // web: py-2 gap-2?
    // mobile: my-3?
    <div className="d-flex w-100 p-2 pe-0">
      <Link
        to={`/discover/messages/${props.conversation.conversationId}`}
        key={props.conversation.conversationId}
        className="no-underline-link d-flex flex-column flex-grow-1"
      >
        <div className="d-flex w-100">
          <span className="p-overlay-badge fs-4">
            <OurImage
              alt="Image"
              default={noProfileImage}
              src={props.conversation.convoPhoto}
              width="100px"
              height="100px"
              rounded="4"
              objectFit="cover"
            />
            {((n) => n ? <Badge value={n}></Badge> : undefined)(props.unread)}
          </span>
          <div className="d-flex flex-column justify-content-center mx-3 flex-grow-1">
            <div className="fs-5 fw-bold d-flex justify-content-between">
              {props.conversation.convoName}
            </div>
            <span>{props.conversation.lastMessage.length > 65 ? props.conversation.lastMessage.substring(0,65)+'...' : props.conversation.lastMessage}</span>
          </div>
        </div>
      </Link>
      <div>
        <div className="d-none">
          <ReportUser
            openDialog={() => setShowBlockReport(true)}
            closeDialog={() => setShowBlockReport(false)}
            isDialogVisible={stateShowBlockReport}
            handleReport={() => handleReport(props.conversation.conversationId)}
            setReportReason={setReportReason}
            reportReason={stateReportReason}
          />
        </div>
        <MenuButton
          className="btn btn-link m-0 p-0"
          menuProps={{
            'popup':true,
            'popupAlignment':'left',
          }}
          items={[
            {
              'label':'Unmatch',
              'icon':'pi pi-close',
              'command':() => dislikeUser(props.conversation.conversationId)
            },
            {
              'label':'Block or Report',
              'icon':'pi pi-flag-fill',
              'command':() => setShowBlockReport(true),
            },
          ]}
          stopPropagation
        >
        </MenuButton>
      </div>
    </div>
  )
}
